/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Block_Static_TextInputs */

const cs_builder_block_static_text = /** @type {(inputs: Builder_Block_Static_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Statický text`)
};

const en_builder_block_static_text = /** @type {(inputs: Builder_Block_Static_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Static text`)
};

/**
* | output |
* | --- |
* | "Static text" |
*
* @param {Builder_Block_Static_TextInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_block_static_text = /** @type {((inputs?: Builder_Block_Static_TextInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Block_Static_TextInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_block_static_text(inputs)
	return cs_builder_block_static_text(inputs)
});